// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "carbon-lab." + {"29":"0f4f9b024a","306":"5d187139e3","526":"baa682ee8d","962":"7f9e1c13b9","966":"6ae44e5db5"}[chunkId] + "." + chunkId + ".chunk.js";
};